module.exports = __webpack_public_path__ + "static/media/8.40fb6796.jpg";